<script setup>
import { useI18n } from 'vue-i18n';
import Footer from '@/components/landing/Footer.vue';
import LandingPageNavBar from '@/components/navigation/LandingPageNavigationBar.vue';
import ImprintList from '../components/ImprintList.vue';

const { t } = useI18n();

const imprints = [
  {
    id: 1,
    title: t('imprintView.siteNotice.title'),
    content: t('imprintView.siteNotice.content'),
  },
  {
    id: 2,
    title: t('imprintView.contact.title'),
    content: t('imprintView.contact.content'),
  },
  {
    id: 3,
    title: t('imprintView.vat.title'),
    content: t('imprintView.vat.content'),
  },
  {
    id: 4,
    title: t('imprintView.euDisputeResolution.title'),
    content: t('imprintView.euDisputeResolution.content'),
  },
  {
    id: 5,
    title: t('imprintView.disputeProceedings.title'),
    content: t('imprintView.disputeProceedings.content'),
  },
];
</script>

<template>
  <LandingPageNavBar />

  <ImprintList
    :title="t('imprintView.title')"
    :imprints="imprints"
  />

  <Footer />
</template>
